export default {
  overviewTitle: 'EmailLogs',
  detailTitle: 'EmailLog',
  deleteTitle: 'dit EmailLog',
  url: '/manage/emaillogs',
  apiUrl: '/emaillogs/',
  sortBy: ['timestamp'],
  sortDesc: [false],
  deletable: false,
  editable: false,
  filterName: 'manage/emaillogs',
  quickFilter: {
    text: 'Zoek op timestamp',
    value: 'timestamp',
    type: 'text'
  },
  newRecord: {
  },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Timestamp', value: 'timestamp', link: '/manage/emaillogs/{id}', filter: 'timestamp_sec', width: '5%'},
    // {text: 'Sender', value: 'sender', width: '10%'},
    {text: 'To', value: 'to', width: '10%'},
    // {text: 'Cc', value: 'cc', width: '10%'},
    // {text: 'Bcc', value: 'bcc', width: '10%'},
    {text: 'Subject', value: 'subject', width: '10%'},
    {text: 'Files', value: 'files', width: '10%'},
    {text: 'Ok', value: 'ok', type: 'boolean', width: '1%'},
    {text: 'Full_Name', value: 'user_full_name', width: '5%'}
  ]
};
